// create a generic angular service that will be overriden in the app module
// that will be used to get the current loggen in user, that can be used to get the
// current user, with their name, and if they are an admin or not
import { Observable, of } from 'rxjs';

export interface CpaasPortalUser {
  id: number;
  name: string;
  isAdmin: boolean;
  isReseller: boolean;
}

export abstract class CpaasUserService {
  public abstract currentCpaasPortalUser(): Observable<CpaasPortalUser | null>;
}
